/* Publish by EComposer at 2026-10-23 09:47:25*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-3fizyt39czq"]=  window.__ectimmers["ecom-3fizyt39czq"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-3fizyt39czq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3fizyt39czq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n2q95fdjsin').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n2q95fdjsin', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mlru3somllb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mlru3somllb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gwuhna6sabg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gwuhna6sabg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6frqngny3yd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6frqngny3yd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1f90z2k98b1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1f90z2k98b1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7tyrzyn6o8r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7tyrzyn6o8r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1q20ozqhc9ij').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1q20ozqhc9ij', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-29kzosvvha7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-29kzosvvha7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rv7bgbvw9wi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rv7bgbvw9wi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mlxb9jioj5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mlxb9jioj5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1yz1swptzjw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1yz1swptzjw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vecjoq68s6h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vecjoq68s6h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dn3nrcb7ssm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dn3nrcb7ssm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t5iuhbgysc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t5iuhbgysc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h0ft0e7l11l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h0ft0e7l11l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gobynmz0utp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gobynmz0utp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v563q49y68o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v563q49y68o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0ovbt6xqzywr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0ovbt6xqzywr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5amy5n48spf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5amy5n48spf', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-v6445j2yg1n"]=  window.__ectimmers["ecom-v6445j2yg1n"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-v6445j2yg1n"]["jddmko8qd"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-v6445j2yg1n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v6445j2yg1n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5qfyjq8jyxv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5qfyjq8jyxv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mvgrgsfo8p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mvgrgsfo8p', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-nq1s3ysr46j"]=  window.__ectimmers["ecom-nq1s3ysr46j"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-nq1s3ysr46j"]["fe0f0yj8s"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-nq1s3ysr46j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nq1s3ysr46j', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9d06iuniuor').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9d06iuniuor', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lvicbugqlrk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lvicbugqlrk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q8vw2wrd1x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q8vw2wrd1x', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}